export default __webpack_public_path__ + "static/media/usdxx-removebg-preview.2d7cf14b.png";